<!--
 * @Description: 该组件在索搜列表中当组件使用
 * @Date: 2020-09-25 18:02:30
-->
<template>
  <div @touchmove="preLoad($event)" class="list">
    <van-tabs v-model="active" sticky type="card" @change="tabChange" class="list-tabs" :swipe-threshold="1" :ellipsis="false">
      <van-tab v-for="(item,index) in moduleList" :key="index" :title="item.moduleName">
        <list v-bind="$data" :defaultMid="true">
          <div
            :class="['list-content',[4,5].includes(type)  ? 'list-content--survey' : '']"
            v-if="moduleList.length"
          >
            <listItem v-for="(item,index) in listData" :key="index" :item="item" :type="type || pType">
              <template #footer>
                <div class="line" v-if="index != listData.length - 1  && type < 3"></div>
              </template>
            </listItem>
          </div>
        </list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { index } from '@/api/ajax';
import { loadMore } from '@/mixins/loadMore';
import listItem from '@/components/list/listItem';
import list from '@/components/list/defaultList.vue';
const map = {
  1: index.informationList,
  2: index.bingliList,
  3: index.courseList,
  4: index.courseList,
  5: index.questionnaireList
};
export default {
  mixins: [loadMore],
  components: { listItem, list },
  props: {
    pType: {
      type: Number,
      default: -1
    },
    searchName: {
      type: String,
      default: ''
    },
    defaultMid: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moduleList: [],
      active: -1,
      type: -1
    };
  },
  computed: {},
  watch: {
    type: {
      immediate: true,
      async handler(v) {
        ~v && this.init(v);
      }
    },
    pType: {
      immediate: true,
      async handler(v) {
        ~v && (this.type = v);
      }
    }
  },
  methods: {
    async getModule(type) {
      if (!this.moduleList.length) {
        let {
          data: { data }
        } = await index.moduleList();
        this.moduleList = data;
      }
      this.active = this.moduleList.findIndex(v => v.moduleType === type);
    },
    // 优先获取当前模块分类
    async init(v) {
      await this.getModule(v);
      this.listAjax = map[v];
      // 防止不存在后错误
      if(!this.listAjax){
        this.$router.replace({name: 'home'})
        return false
      }
      this.pageObj.searchName = this.searchName;
      this.pageObj.courseType = v === 3 ? 1 : 2; // type类型对应courseType类型
      this.getList({ init: true });
    },
    tabChange(v) {
      this.type = this.moduleList[v].moduleType;
    }
  },
  // listType与pType必定只有一个
  created() {
    this.type = +this.$route.query.listType || this.pType || -1;
  },
  activated() {
    this.type = +this.$route.query.listType || this.pType || -1;
  }
};
</script>
<style lang='less' scoped>
.list {
  padding: 0.1rem 0;
  &-tabs {
  }
  /deep/ &-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 0.43rem;
    margin-top: 0.1rem;
    &--survey {
      padding-bottom: 0.32rem;
      /deep/ .common {
        padding-bottom: 0;
      }
    }
  }
  /deep/ .van-tabs {
    min-height: 80vh;
  }
  /deep/.van-tabs__wrap {
    background: #fff;

    .van-tabs__nav--card {
      border: none;
      .van-tab {
        border: none;
        .van-tab__text {
          color: #959599;
          font-size: 0.43rem;
        }
      }
      .van-tab--active {
        background: #3667ec;

        border-radius: 0.21rem;
        .van-tab__text {
          color: #fff;
        }
      }
    }
  }
}
</style>